module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-oee-ui-mobile.en-7ab081308d0be7c2e99b6e0bb7c011ff.png";